var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Api as apiService } from '../api';
export class CardRequestAPI {
    static get(cardRequestId) {
        return apiService.responseToJSONAndToastError(apiService.get(`${CardRequestAPI.cardRequestUrl}/${cardRequestId}`));
    }
    static getCardRequests(params) {
        var _a, _b, _c, _d, _e;
        return __awaiter(this, void 0, void 0, function* () {
            const searchParams = new URLSearchParams({
                section: params.section ? params.section.toString() : '',
                limit: (_a = params.limit) === null || _a === void 0 ? void 0 : _a.toString(),
                offset: (_b = params.offset) === null || _b === void 0 ? void 0 : _b.toString(),
                order: params.order || 'desc',
                sort: params.sort || 'created_at'
            });
            const filters = [];
            if ((_c = params.filters) === null || _c === void 0 ? void 0 : _c.hasOwnProperty('dismissed')) {
                filters.push({ field: 'dismissed', value: params.filters.dismissed });
            }
            if ((_d = params.filters) === null || _d === void 0 ? void 0 : _d.hasOwnProperty('user_id')) {
                filters.push({ field: 'user_id', value: params.filters.user_id });
            }
            if (filters.length > 0) {
                searchParams.append('filters', JSON.stringify(filters));
            }
            (_e = params.include) === null || _e === void 0 ? void 0 : _e.forEach((field) => {
                searchParams.append('include', field);
            });
            return apiService.responseToJSONAndToastError(apiService.get(`${CardRequestAPI.cardRequestUrl}?${searchParams}`));
        });
    }
    static create(data) {
        return apiService.responseToJSONAndToastError(apiService.post(CardRequestAPI.cardRequestUrl, data));
    }
    static update(data) {
        return apiService.responseToJSONAndToastError(apiService.put(CardRequestAPI.cardRequestUrl, data));
    }
    static updateStatus(cardRequestId, status, cardRequestAction, denyReason, cardRequestPayload) {
        return apiService.responseToJSONAndToastError(apiService.patch(`${CardRequestAPI.cardRequestUrl}/${cardRequestId}/status`, {
            status,
            denyReason,
            fieldsToUpdate: cardRequestPayload,
            action: cardRequestAction
        }));
    }
    static dismiss(cardRequestId) {
        return apiService.responseToJSONAndToastError(apiService.patch(`${CardRequestAPI.cardRequestUrl}/${cardRequestId}/dismiss`));
    }
    static remind(cardRequestId) {
        return apiService.responseToJSONAndToastError(apiService.post(`${CardRequestAPI.cardRequestUrl}/${cardRequestId}/remind`));
    }
    static denyAllUserCardRequests(userProfileIds) {
        return apiService.post(`${CardRequestAPI.cardRequestUrl}/deny_all`, { userProfileIds });
    }
    static getJourney(cardRequestId) {
        return apiService.responseToJSONAndToastError(apiService.get(`${CardRequestAPI.cardRequestUrl}/${cardRequestId}/journey`));
    }
    static getIsIssuableByApprover(cardRequestId) {
        return apiService.responseToJSONAndToastError(apiService.get(`${CardRequestAPI.cardRequestUrl}/${cardRequestId}/approver_issuable_state`));
    }
}
CardRequestAPI.cardRequestUrl = '/api/card_requests';
